import React from 'react'

import './index.scss'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import { WriterModel } from '@Entities/work/writer-model'

interface CellDisplayListProps {
    items: WriterModel[]
    onAddToListClicked?: () => void
    onRemoveFromListClicked?: (writer: WriterModel) => void
    readOnly?: boolean
}

const CellDisplayList = ({ items, onAddToListClicked, onRemoveFromListClicked, readOnly }: CellDisplayListProps) => (
    <div className="cell-display-list">
        {items.map((writer) => (
            <div className="list-item" key={writer.ipId}>
                <span>
                    {writer.firstName} {writer.lastName}
                </span>
                {onRemoveFromListClicked && !readOnly && (
                    <button className="remove-from-list-button" onClick={() => onRemoveFromListClicked(writer)}>
                        <img src={ICONS.close} alt="remove-from-list-button" />
                    </button>
                )}
            </div>
        ))}
        {onAddToListClicked && (
            <Button disabled={readOnly} mainColor type="primary" onClick={onAddToListClicked}>
                Link Writer
            </Button>
        )}
    </div>
)

export default CellDisplayList
